import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css"; 
import logo from "../assets/66826e00fddae23ee8d69cb6217278d46a998ae6.png";
import logout from "../assets/logout.svg";
import userIcon from "../assets/5400308.png";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const userData = localStorage.getItem("gp_user");
    
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUserName(parsedUser.name || parsedUser.username || "User");
        setUserEmail(parsedUser.email || "");
      } catch (error) {
        console.error("Invalid user JSON", error);
      }
    } else {
      console.log("No user data found in localStorage");
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("auth");
    localStorage.removeItem("gp_token");
    localStorage.removeItem("gp_phone");
    localStorage.removeItem("gp_user");

    navigate("/");
    window.location.reload();
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="header-set">
      <header className="header">
        <div className="branding" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
          <img src={logo} alt="logo" className="logo" />
        </div>

        <div className="user-section" ref={dropdownRef}>
          <div className="user-info" onClick={toggleDropdown}>
            <img src={userIcon} alt="user" className="user-icon" />
            <span className="user-name">Welcome, {userName}</span>
            <svg 
              className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} 
              width="12" 
              height="8" 
              viewBox="0 0 12 8" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M1 1.5L6 6.5L11 1.5" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-item user-detail">
                <div className="dropdown-user-icon">
                  <img src={userIcon} alt="user" />
                </div>
                <div className="dropdown-user-info">
                  <div className="dropdown-user-name">{userName}</div>
                  <div className="dropdown-user-email">{userEmail}</div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-item" onClick={handleLogout}>
                <img src={logout} alt="logout-icon" className="dropdown-logout-icon" />
                Logout
              </button>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default Header;